import type { Sale } from "@/types/sales/api-types/sale-types";

export const EM_DASH = "—";
/** Seeded walk-in placeholder (`first_name` + `last_name` on SaleRead.client_name). */
const WALK_IN_CLIENT_NAME = "Walk in Customer";

const uniqueNames = (names: (string | null | undefined)[]): string => {
  const seen = new Set<string>();
  const ordered: string[] = [];
  for (const name of names) {
    const trimmed = name?.trim();
    if (!trimmed || seen.has(trimmed)) continue;
    seen.add(trimmed);
    ordered.push(trimmed);
  }
  return ordered.join(", ");
};

export const saleStylistColumn = (sale: Sale): string => {
  const fromServices = uniqueNames(sale.services.map((line) => line.staff_name));
  if (fromServices) return fromServices;
  const fromProducts = uniqueNames(sale.products.map((line) => line.staff_name));
  return fromProducts || EM_DASH;
};

/** The sale's earliest start (`HH:MM`), or null for a walk-in or a sale without services. */
export const saleStartTime = (sale: Sale): string | null => {
  if (sale.client_name === WALK_IN_CLIENT_NAME) return null;
  const starts = sale.services
    .map((line) => line.start_time)
    .filter((time) => Boolean(time));
  if (starts.length === 0) return null;
  return starts.reduce((earliest, time) =>
    time < earliest ? time : earliest
  );
};
